import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { RightDrawerStore, FetchEconomicsRankingUnifiedAsync } from '@flexo/reducers';
import { useLocation, useParams } from 'react-router-dom';

export const EconomicsCommunityRankingResolver = () => {
  
  const dispatch = useDispatch();
  const location = useLocation();
  const params = useParams();
  const calendar = useSelector((state: any) => state.calendar);
  const metadata = useSelector((state: any) => state.metadata);
  const pathSegment = location.pathname.split('/')[1]; 

  const { hiveCalendar } = calendar;
  const { selectedDate, selectedTimeSet } = hiveCalendar;

  async function init() {

    if (!location.pathname.includes('community')) { return; }

    const COMMUNITY_ID = params?.id || metadata?.selectedEntity?.communityId || null;

    if (!COMMUNITY_ID) { return; }

    const ENV = (import.meta as any).env;
    const org = ENV?.VITE_APP_ORG || 'base';
    const totalSites = ((metadata?.entities as any)?.site || [])
      .filter((s: any) => s?.communityId === COMMUNITY_ID).length;
    const fetchAll = RightDrawerStore()?.show === true && RightDrawerStore()?.type === 'HORIZONTAL_CHART';

    // Token auto-injected by httpService interceptor
    dispatch((FetchEconomicsRankingUnifiedAsync as any)({
      org,
      scope: 'community',
      entityId: COMMUNITY_ID,
      totalSites,
      selectedDate,
      selectedTimeSet,
      fetchAll,
    }));
  }

  useEffect(() => {
    init();
  }, [selectedDate, pathSegment, params?.id]);

  return <></>;
};
